module.exports = __webpack_public_path__ + "static/media/6-无线根管预备机Mini.587fbe83.jpg";